import React, { useEffect, useState } from 'react'
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { useDispatch, useSelector } from "react-redux";
import { addEnrollment, updateEnrollment } from '../actions/enrollmentActions';


export const Enrollment = ({ closePopup, subjectInstanceId, studentId, edit, enrollmentId }) => {

    const enrollmentsArray = useSelector((state) =>
        state.enrollments ? state.enrollments : null);
    const subjectInstancesArray = useSelector((state) =>
        state.subjectInstances ? state.subjectInstances : null);
    const studentsArray = useSelector((state) =>
        state.students ? state.students : null);
    const studentSelected = useSelector((state) =>
        state.selection.selectedStudent ? state.selection.selectedStudent : null);
    const subjectInstanceSelected = useSelector((state) =>
        state.selection.selectedSubjectInstance ? state.selection.selectedSubjectInstance : null);


    const [selectedStudent, setSelectedStudent] = useState("");
    const [selectedSubject, setSelectedSubject] = useState("");
    const [selectedSchedule, setSelectedSchedule] = useState("");


    const dispatch = useDispatch();


    useEffect(() => {
        if (edit && studentSelected && subjectInstanceSelected) {
            setSelectedStudent(studentSelected);
            setSelectedSubject(subjectInstanceSelected);
            setSelectedSchedule(enrollmentsArray.find(en=>en._id==enrollmentId).schedule.toString());
           
        } else {
            if (studentSelected) {

                setSelectedStudent(studentSelected);
                const avaiableSubjectsforThatStudent = subjectInstancesArray?.filter(SubjIn => !enrollmentsArray.some(enrollment =>
                    (enrollment.student?._id === studentSelected?._id) && (enrollment.subjectInstance?._id === SubjIn?._id)));
                setSelectedSubject(avaiableSubjectsforThatStudent[0]);

            } else {
                if (subjectInstanceSelected) {
                    const avaiableStudents = studentsArray?.filter(st =>
                        !enrollmentsArray.some(enrollment =>
                            enrollment.subjectInstance?._id === subjectInstanceSelected?._id &&
                            enrollment.student?._id === st?._id
                        )
                    )
                    setSelectedSubject(subjectInstanceSelected);
                    setSelectedStudent(avaiableStudents[0]);

                } else {
                    const avaiableStudents = studentsArray?.filter(st =>
                        !enrollmentsArray.some(enrollment =>
                            enrollment.student?._id === st?._id
                        )
                    )
                    const selectedStudent = avaiableStudents[0];
                    const avaiableSubjectsforThatStudent = subjectInstancesArray?.filter(SubjIn => !enrollmentsArray.some(enrollment =>
                        (enrollment.student?._id === selectedStudent?._id) && (enrollment.subjectInstance?._id === SubjIn?._id)));

                    setSelectedStudent(selectedStudent);
                    setSelectedSubject(avaiableSubjectsforThatStudent[0]);
                }
            }
        }

    }, []);
    useEffect(() => {
        if (selectedSubject && selectedSubject.schedule && !edit && selectedSubject.schedule.length >= 0) {
            setSelectedSchedule(selectedSubject.schedule[0]);
        }

        
    }, [selectedSubject]);


    const handleSubjectChange = (e) => {
        const selectedSubjectId = e.target.value;
        const defaultSubject = subjectInstancesArray.find(subjIn => subjIn._id === selectedSubjectId);
        setSelectedSubject(defaultSubject);
    };
    const handleStudentChange = (e) => {
        const selectedStudentId = e.target.value;
        const selectedStudent = studentsArray.find(st => st._id === selectedStudentId);
        setSelectedStudent(selectedStudent);
    };
    const handleSave = async () => {

        if (!edit) {
            const today = new Date();
            const inputc = {
                studentId: selectedStudent._id,
                subjectInstanceId: selectedSubject._id,
                enrollmentDate: today.toISOString().split('T')[0],
                schedule: selectedSchedule,
                status: "enrolled",
            };
            dispatch(addEnrollment(inputc));
        } else {
            
            const inputu = {
                enrollmentId: enrollmentsArray.find(en=>en._id==enrollmentId)._id,
                schedule: selectedSchedule.toString(),
            };
            dispatch(updateEnrollment(inputu));

        }
    };

    return (
        <FormWrapper>

            <Label>
                Student:
                <Select
                    value={selectedStudent?._id}
                    onChange={(e) => { handleStudentChange(e) }}
                    disabled={edit ? true : false}
                >
                    {!edit && studentsArray && studentsArray.filter(student => {
                        return !enrollmentsArray.some(enrollment =>
                            enrollment.student._id === student._id &&
                            enrollment.subjectInstance._id === selectedSubject?._id
                        );
                    }).map((student, index) => (
                        <option key={index} value={student._id}>{student.name}</option>
                    ))}
                    {edit && (
                        <option value={selectedStudent?._id}>
                            {selectedStudent?.name}
                        </option>
                    )}
                </Select>
            </Label>
            <Label>
                Subject:
                <Select
                    value={selectedSubject?._id}
                    onChange={(e) => { handleSubjectChange(e) }}
                    disabled={edit ? true : false}
                >
                    {!edit && subjectInstancesArray && subjectInstancesArray.filter((subjectInstance, index, self) =>
                        index === self.findIndex((t) => (
                            t.subject.name === subjectInstance.subject.name
                        ))
                    ).filter(subjectInstance => {
                        return !enrollmentsArray.some(enrollment =>
                            enrollment.subjectInstance.subject.name === subjectInstance.subject.name &&
                            enrollment.student._id === selectedStudent?._id
                        );
                    })
                        .map((subjectInstance, index) => (
                            <option key={index} value={subjectInstance._id}>{subjectInstance.subject.name}</option>
                        ))}
                         {edit && (
                        <option value={selectedSubject?._id}>
                            {selectedSubject?.subject?.name}
                        </option>
                    )}
                </Select>
            </Label>
            <Label>
                Schedule:
                <Select
                    value={selectedSchedule}
                    onChange={(e) => { setSelectedSchedule(e.target.value) }}
                >
                    {selectedSubject && selectedSubject.schedule && selectedSubject.schedule.map((item, index) => (

                        <option key={index} value={item}>{item}</option>
                    ))}
                </Select>
            </Label>
            <Button onClick={() => handleSave()}>Save</Button>
        </FormWrapper>
    );
};


export default Enrollment;
